import { Data, UI, Utils } from 'common';
import isFunction from 'lodash/isFunction';
import React, { useEffect, useState } from 'react';
import { DataDisplayPanel } from './DataDisplayPanel.component';

const { Capability, InternalCapability, Carrier } = Data;
const { WrappedDropdownWithLabel } = UI;
const { Session } = Utils;

const ReferencePanel = ({
	labelAndOrderDetails,
	costCodeOptions,
	printDetails,
	setPrintsCostCode,
	onClickManageCostCodes,
}) => {
	const { labelDetails = {} } = labelAndOrderDetails;
	const { printTypeName, orderId = '', carrier } = printDetails;
	const { references = {}, username, isQrCode, manifestId = '' } = labelDetails;
	const { reference1 = '', reference2 = '', reference3 = '' } = references;

	const reference1Label =
		carrier === Carrier.FedEx ? 'Cust. Reference:' : 'Reference 1:';
	const reference2Label =
		carrier === Carrier.FedEx ? 'Invoice #:' : 'Reference 2:';
	const reference3Label =
		carrier === Carrier.FedEx ? 'Purchase Order #:' : 'Reference 3:';
	const [costCodeId, setCostCodeId] = useState(references.costCodeId);

	// update costCodeId when labeldetails change to prevent retaining old ID
	useEffect(() => {
		setCostCodeId(references.costCodeId);
	}, [references.costCodeId]);

	const onChangeCostCode = ({ value }) => {
		if (value === -1) {
			if (isFunction(onClickManageCostCodes)) {
				onClickManageCostCodes();
			}
		} else {
			setCostCodeId(value);
			if (isFunction(setPrintsCostCode)) {
				setPrintsCostCode(value);
			}
		}
	};

	const referenceDataDisplay = [
		{
			body: username,
			dataqa: 'username',
			label: 'User:',
		},
		{
			body: isQrCode ? 'Drop-Off: No Label Needed' : printTypeName,
			dataqa: 'username',
			label: 'Printed On:',
		},
		{
			body: reference1,
			dataqa: 'reference-1',
			label: reference1Label,
		},
		{
			body: reference2,
			dataqa: 'reference-2',
			label: reference2Label,
		},
		{
			body: reference3,
			dataqa: 'reference-3',
			label: reference3Label,
		},
		{
			body: manifestId,
			dataqa: 'scan-form-number',
			label: 'SCAN Form ID:',
		},
		{
			body: orderId,
			dataqa: 'order-id',
			label: 'Order ID:',
		},
	];

	return (
		<div className="reference-panel">
			{Session.hasCapability(Capability.CostCodes) && (
				<WrappedDropdownWithLabel
					label="Cost Code:"
					className="cost-code data-display p-col-12"
					uiElementConfig={{
						name: 'costCodes',
						placeholder: 'Any',
						options: Session.hasCapability(InternalCapability.EditCostCodes)
							? [
									{
										code: 'Add/Edit Cost Codes',
										id: -1,
									},
									...costCodeOptions,
									{
										code: 'None',
										id: 0,
									},
								]
							: [
									...costCodeOptions,
									{
										code: 'None',
										id: 0,
									},
								],
						optionLabel: 'code',
						optionValue: 'id',
						value: costCodeId,
						onChange: onChangeCostCode,
						dataqa: 'reference-cost-code',
					}}
				/>
			)}
			{referenceDataDisplay.map(
				(referenceDetail, i) =>
					referenceDetail.body && (
						<DataDisplayPanel
							label={referenceDetail.label}
							body={referenceDetail.body}
							dataqa={referenceDetail.dataqa}
							key={`${referenceDetail.dataqa}_${i}`}
						/>
					)
			)}
		</div>
	);
};

export default ReferencePanel;
